import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

const checkoutEmailUpdate = (
	`mutation checkoutEmailUpdateV2($checkoutId: ID!, $email: String!) {
		checkoutEmailUpdateV2(checkoutId: $checkoutId, email: $email) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutEmailUpdate;
